var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ADADD0",
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11c0-5.5-4.5-10-10-10S1 5.5 1 11s4.5 10 10 10 10-4.5 10-10z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    opacity: 0.6,
    d: "M11 7h.1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    opacity: 0.6,
    d: "M10.995 15h.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon-admin.d7d5e73107cd638df7f0d9cd9e1dc172.svg";
export { ForwardRef as ReactComponent };